import moment from 'moment';
import { DATE_TIME_FORMAT } from '../constants';
import { YEAR_DATE_FORMAT } from '../constants';

export const formatSaveStatus = (status) => {
  switch (status) {
    case 'PENDING':
      return 'Saving...';
    case 'SUCCEEDED':
      return 'Saved.';
    case 'FAILED':
      return 'Failed';
    default:
      return '';
  }
};

export const toGb = (amount) => {
  if (amount === 0 || amount === '0') {
    return '0';
  }

  if (!amount) {
    return '';
  }

  return amount / 1024;
};

const titleCase = (str) => {
  return str
    .toLowerCase()
    .split(' ')
    .map(function (word) {
      return word.replace(word[0], word[0].toUpperCase());
    })
    .join(' ');
};

export const prettyKey = (key) => {
  switch (key) {
    case 'icc_id':
      return 'ICCID';
    case 'mdn':
      return 'MDN';
    default:
      return titleCase(key.replace(/_/g, ' '));
  }
};

export const formatDateForAPI = (date) => {
  if (date && Date.parse(date)) {
    return moment(date).format(DATE_TIME_FORMAT);
  }
  return void 0;
};

export const formatDateTimeUtc = (date) => {
  if (date && Date.parse(date)) {
    return moment.utc(date).format(DATE_TIME_FORMAT);
  }
  return void 0;
};

export const formatDateWithoutTimeForAPI = (date) => {
  return formatDateForSprintCallsAndSMSAPI(date);
};

export const formatDateForSprintCallsAndSMSAPI = (date) => {
  if (date && Date.parse(date)) {
    return moment(date).format(YEAR_DATE_FORMAT);
  }
  return void 0;
};

export const formatDateForAttVoiceAndSMSRecordsAPI = (date) => {
  if (date && Date.parse(date)) {
    return moment(date).format('YYYY-MM-DD[T]HH:mm:ss');
  }
  return void 0;
};

export const formatEmptyTableData = (data) => {
  if (data === null || data === void 0) return '-';

  return data;
};
